module.exports = __webpack_public_path__ + "img/ej-04.e1e82735.svg";